import { defineStore, skipHydrate } from 'pinia'
import type { TIcons } from '@/components/icon/types'
import { useSessionStorage } from '@vueuse/core'

export const useMultiStepStore = defineStore('multiStep', () => {
  const showMultiStepForm = useSessionStorage('showMultiStepFrom', false)
  const startStep = useSessionStorage('startStep', 1)
  const maxStep = useSessionStorage('maxStep', 1)
  const currentStep = useSessionStorage('currentStep', 1)
  const stepsData = useSessionStorage<{ title: string; icon: TIcons; step: number }[]>('stepsData', [])
  const dataFieldsPreview = useSessionStorage<{ data: string[]; title: string; step: number }[]>(
    'dataFieldsPreview',
    []
  )
  const triggerSubmit = useSessionStorage('triggerSubmit', false)
  const isFormSubmittedSuccessfully = useSessionStorage('isFormSubmittedSuccessfully', false)
  const showLoading = ref(false)

  function prevStep() {
    currentStep.value = currentStep.value === 1 ? currentStep.value : currentStep.value - 1
  }

  function nextStep() {
    currentStep.value = isLastStep.value ? currentStep.value : currentStep.value + 1
  }

  function goTo(step: number) {
    if (step >= 1 && step <= maxStep.value) {
      currentStep.value = step

      return
    }

    if (isDev()) {
      console.warn(`Step ${step} is out of range`)
    }
  }

  const isLastStep = computed(() => currentStep.value === maxStep.value)

  function resetStates() {
    showMultiStepForm.value = false
    currentStep.value = 1
    stepsData.value = []
    dataFieldsPreview.value = []
    triggerSubmit.value = false
    isFormSubmittedSuccessfully.value = false
    showLoading.value = false
  }

  return {
    showMultiStepForm: skipHydrate(showMultiStepForm),
    startStep,
    currentStep: skipHydrate(currentStep),
    maxStep,
    stepsData: skipHydrate(stepsData),
    dataFieldsPreview: skipHydrate(dataFieldsPreview),
    triggerSubmit: skipHydrate(triggerSubmit),
    prevStep,
    nextStep,
    goTo,
    isLastStep,
    resetStates,
    isFormSubmittedSuccessfully: skipHydrate(isFormSubmittedSuccessfully),
    showLoading
  }
})
